import type { GetComponentQueryKey, UseGetComponentParams } from './types';

export const getComponentQueryKey = (
  params: UseGetComponentParams,
): GetComponentQueryKey => ['quotes', 'components', 'component', params];
